module.exports = function getResource(label) {
    let resources = {
        your: 'Votre ',
        colorIQMatch: 'correspondance Color iQ.',
        colorIQ: 'Voir votre correspondance Color iQ'
    };
    return resources[label];
};
